// extracted by mini-css-extract-plugin
module.exports = {"container":"_1xZsWwU3-0frUf5Gu08_hL","mainField":"_2sgY3IrljpOTx1ZzFStbiJ","additionalFields":"_2XD2jk1uRbaktVVWBTLG7j"};